import React from "react";

function Header() {
  return (
    <React.StrictMode>
      <div className="menubar">
        <div className="menubar-content">
          <nav className="navbar navbar-default navbar-fixed-top">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-sm-3">
                  <div className="site-title">
                    <a href="/" style={{ textDecoration: "none" }}>
                      <h3 style={{marginTop: '17px'}}>
                      <img height={40} src="assets/img/CA-logo-min.webp" alt="CA Logo" />&nbsp;
                        Harsha Reddy</h3>
                    </a>
                  </div>
                </div>
                <div className="navbar-header">
                  <button
                    type="button"
                    className="navbar-toggle collapsed"
                    data-toggle="collapse"
                    data-target="#bs-example-navbar-collapse-1"
                    aria-expanded="false"
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>
                <div className="col-md-8 col-sm-9 navbar-style">
                  <div
                    className="collapse navbar-collapse"
                    id="bs-example-navbar-collapse-1"
                  >
                    <ul className="nav navbar-nav">
                      <li>
                        <a href="#home">
                          Home
                        </a>
                      </li>
                      <li>
                        <a href="/#about" className="active">About</a>
                      </li>
                      <li>
                        <a href="/#service">Service</a>
                      </li>
                      {/* <li>
                        <a href="/#service">Service</a>
                      </li> */}
                      <li>
                        <a href="/#blog">Blog</a>
                      </li>
                      <li>
                        <a href="/#contact">Contact</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </React.StrictMode>
  );
}

export default Header;
